import type { ReactNode } from "react";
import { useSelector } from "react-redux";
import { getIsPricedOnGridV2 } from "./selectors";

export interface GridV2GateProps {
  /** Shown to users priced on Grid V2. */
  children: ReactNode;
  /** Shown to everyone else, including while the version is unresolved. */
  fallback?: ReactNode;
}

/**
 * Shows Grid V2 merchandising only to users the BFF prices on Grid V2, so not
 * to a variant user who opted out. No wrapper element, no styles: it is a
 * switch, not UI.
 */
export const GridV2Gate = ({ children, fallback = null }: GridV2GateProps) => {
  const isPricedOnGridV2 = useSelector(getIsPricedOnGridV2);
  return <>{isPricedOnGridV2 ? children : fallback}</>;
};
